export enum EUserType {
	Admin = 'Admin',
	Regular = 'Regular',
}

export enum ESearchType {
	EQUALS = 'EQUALS',
	CONTAINS = 'CONTAINS',
	BETWEEN = 'BETWEEN'
}

export enum EUserStatus {
	Pending = 'Pending',
	Approved = 'Approved'
}

export enum NotificationType {
	SMS = 'SMS',
	Email = 'Email',
	All = 'All'
}

export enum EGender {
	Male = 'Male',
	Female = 'Female'
}

export enum ETrainingType {
	Toning = 'Toning',
	Mass = 'Mass'
}

export enum EExtendedUserType {
	Coach = 'Coach',
	Trainee = 'Trainee',
	Organization = 'Organization'
}

export enum ETrainingMenuType {
	Toning = 'Toning',
	Mass = 'Mass',
	Vegetarian = 'Vegetarian'
}

export enum EPeriod {
	Hours = 'Hours',
	Days = 'Days',
	Weeks = 'Weeks',
	Months = 'Months'
}

export enum ERecipient {
	All = 'All',
	Coach = 'Coach',
	Trainee = 'Trainee'
}

export enum EPlatform {
	AdminPanel = 'AdminPanel',
	App = 'App',
	Web = 'Web'
}

export enum ELanguage {
	Hebrew = 'he',
	English = 'en',
	Spanish = 'es',
	Portuguese = 'pt',
	Italian = 'it',
}

export enum EDayOfWeek {
	Sunday = 'Sunday',
	Monday = 'Monday',
	Tuesday = 'Tuesday',
	Wednesday = 'Wednesday',
	Thursday = 'Thursday',
	Friday = 'Friday',
	Saturday = 'Saturday',
}
